import { z } from "zod";
import { EQUIPMENT, sameEquipmentKey } from "@frontier/content/arsenal";
import { equipmentKeySchema, upgradePriceVersionSchema } from "./contracts.js";

const costSchema = z
  .object({
    credits: z
      .string()
      .regex(/^[1-9][0-9]*$/)
      .max(18),
    components: z.number().int().positive().max(1_000_000),
  })
  .strict();
export const upgradePricesSchema = z
  .object({
    version: upgradePriceVersionSchema,
    items: z
      .array(
        z
          .object({
            key: equipmentKeySchema,
            priceClass: z.enum(["standard", "advanced", "special"]),
            steps: z.tuple([costSchema, costSchema]),
          })
          .strict(),
      )
      .length(EQUIPMENT.length)
      .refine(
        (items) =>
          EQUIPMENT.every(
            ({ key }) =>
              items.filter((item) => sameEquipmentKey(item.key, key)).length ===
              1,
          ),
        "Expected one price for every item",
      ),
  })
  .strict();
export type UpgradePrices = z.infer<typeof upgradePricesSchema>;
